export const IMAGE_MANIFEST = [
  '/_static-files/img/coin.png',
  '/_static-files/img/coin-sprite.png',
  '/_static-files/img/lime-circle.png',
  '/_static-files/img/mock-product.png',
  '/_static-files/img/polygon.png',
  '/_static-files/img/prize-card-glow.png',
  '/_static-files/img/prize-modal-glow.png',
  '/_static-files/img/recieved.png',
  '/_static-files/img/silver-circle.png',
  '/_static-files/img/prizes/language-switcher.png',
  '/_static-files/img/prizes/promo_modal.png',
  '/_static-files/img/home-bg-ru.webp',
  '/_static-files/img/home-bg-kz.webp',
  '/_static-files/img/home-glow.webp',
  '/_static-files/img/rating-bg.webp',
  '/_static-files/img/avatar-default.png',
  '/_static-files/img/avatar-didnt-play.png',
  '/_static-files/img/places/IMG_1.webp',
  '/_static-files/img/places/IMG_2.webp',
  '/_static-files/img/places/IMG_3.webp',
]

export const RATING_PLACE_IMAGE_DIR = '/_static-files/img/places'

/** Максимальная позиция, для которой есть цифровая аватарка места */
export const RATING_PLACE_MAX = 50

export const PROFILE_DEFAULT_AVATAR_SRC =
  '/_static-files/img/avatar-default.png'

export const PROFILE_DIDNT_PLAY_AVATAR_SRC =
  '/_static-files/img/avatar-didnt-play.png'

/** Максимальная позиция в рейтинге, для которой в профиле показывается аватарка с номером места */
export const PROFILE_RANK_AVATAR_MAX_PLACE = RATING_PLACE_MAX
